@if(!isMobile) {
    <div class="cursor-pointer hidden md:inline" (click)="op.toggle($event)">
      @if(user()!.profilePic && user()!.profilePic !== '') {
        <p-avatar [image]="user()!.profilePic" shape="circle" />
    } @else { 
        <p-avatar [label]="user()!.name[0] + user()!.lastname[0]" shape="circle" />

    }
      </div>
    <p-popover #op styleClass="!p-0">
      <div class="flex flex-col w-[16rem] p-0">
          <div class="border-b border-surface-100 p-2">
            <div class="text-bold text-sm font-bold">{{ roleName }}</div>
          <div class="text-sm">
            {{ user()?.email }}</div
          >
          </div>
          <div class="flex flex-col">
            @if(sugerirFichajeEntrada()) {
              <p-button severity="secondary" [link]="true" size="small"  (onClick)="showDialog(); op.hide()"
            >Fichar entrada</p-button
          >
            }
            @if(sugerirFichajeSalida() && !sugerirFichajeEntrada()) {
              <p-button severity="secondary" [link]="true" size="small"  (onClick)="fp.toggle($event);"
            >Fichar salida</p-button
          >
          <p-popover #fp>
            @if(lastFichaje()) {
              <app-fichaje-endwork [id]="user()?.uid!" [lastFichaje]="lastFichaje()!" (onDrawerlose)="loadData(); fp.toggle($event)" />

            }
        </p-popover>
            }
            <p-button severity="secondary" [link]="true" size="small"  (onClick)="goToMyProfile()"
            >Perfil empleado</p-button
          >
            <p-button severity="danger" [link]="true" styleClass="text-red-400" size="small" (onClick)="signout()"
            >Cerrar sesión</p-button
          >
          </div>
        </div>
      </p-popover>
}@else {
  <div class="flex flex-row items-center border-t justify-between border-surface-100 py-3  cursor-pointer" (click)="goToMyProfile()">
    <div class="flex flex-row items-center gap-3">
      <p-avatar [label]="(user()?.name)![0]" ></p-avatar>
    <p>{{ user()?.name }} {{ user()?.lastname }}</p>
    </div>
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
      </svg>
    </div>
  </div>
}

<p-dialog header="Fichaje de entrada" [(visible)]="visible" [modal]="true" [style]="{ width: '35rem' }">
  <app-fichaje-start (fichaje)="onEntradaRegistrada()" />
</p-dialog>
